/** Floor matches the previous “grown” list height for a full page of rows. */
export const LIST_GRID_MIN_HEIGHT = 550

/** Grey-header note + content-inner bottom padding below the grid. */
export const LIST_VIEW_BOTTOM_RESERVE_PX = 104

/**
 * Header + page title + properties nav + list card header, used only for the
 * first paint before the grid has a layout box.
 */
export const LIST_VIEW_ESTIMATED_TOP_PX = 360

export function getListGridFillHeight(
  gridTop,
  viewportHeight,
  bottomReserve = LIST_VIEW_BOTTOM_RESERVE_PX,
) {
  const available = viewportHeight - gridTop - bottomReserve
  return Math.max(LIST_GRID_MIN_HEIGHT, Math.floor(available))
}

export function getInitialListGridHeight(
  viewportHeight =
    typeof window !== 'undefined'
      ? window.innerHeight
      : LIST_GRID_MIN_HEIGHT,
) {
  return getListGridFillHeight(
    LIST_VIEW_ESTIMATED_TOP_PX,
    viewportHeight,
  )
}
